import type { ReactNode } from "react";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

function Panel({ children, className = "" }: { children?: ReactNode; className?: string }) {
  return <Card className={`rounded-2xl border-dash-border p-6 shadow-none ${className}`}>{children}</Card>;
}

export default function BillingSkeleton() {
  return (
    <div className="w-full font-dashboard" role="status" aria-label="Loading billing">
      <Skeleton className="h-9 w-48" />
      <Skeleton className="mt-3 h-4 w-96 max-w-full" />
      <div className="mt-10 grid items-start gap-5 lg:grid-cols-[minmax(0,2fr)_minmax(290px,1fr)]">
        <div className="flex flex-col gap-5">
          <Panel>
            <div className="flex justify-between gap-5"><div><Skeleton className="h-3 w-24" /><Skeleton className="mt-3 h-7 w-32" /><Skeleton className="mt-2 h-4 w-56" /></div><Skeleton className="h-10 w-28" /></div>
            <div className="mt-6 grid grid-cols-2 gap-4 border-t border-dash-border pt-5 sm:grid-cols-4">{[0, 1, 2, 3].map((item) => <div key={item}><Skeleton className="h-3 w-20" /><Skeleton className="mt-2 h-4 w-16" /></div>)}</div>
          </Panel>
          <Panel><Skeleton className="h-5 w-44" />{[0, 1].map((item) => <div key={item} className="mt-6"><div className="flex justify-between"><Skeleton className="h-4 w-24" /><Skeleton className="h-4 w-28" /></div><Skeleton className="mt-3 h-2 w-full rounded-full" /></div>)}</Panel>
          <Panel><Skeleton className="h-5 w-32" />{[0, 1, 2].map((row) => <div key={row} className="mt-5 flex gap-6"><Skeleton className="h-4 flex-1" /><Skeleton className="h-4 flex-1" /><Skeleton className="h-4 w-20" /></div>)}</Panel>
        </div>
        <div className="flex flex-col gap-5">
          <Panel><Skeleton className="h-5 w-32" /><Skeleton className="mt-5 h-16 w-full rounded-xl" /></Panel>
          <Panel><Skeleton className="h-5 w-36" />{[0, 1, 2, 3].map((item) => <Skeleton key={item} className="mt-4 h-4 w-full" />)}<Skeleton className="mt-6 h-10 w-full" /></Panel>
        </div>
      </div>
      <span className="sr-only">Loading billing details…</span>
    </div>
  );
}
